export const stages = [
  {
    stage: 1,
    cefr: 'A1',
    questions: [
      { id: 'A1-PL-Q1', type: 'multiple_choice', skill: 'grammar', question: 'Ja ___ studentem.', options: ['jestem', 'jesteś', 'jest', 'są'], answer: 'jestem' },
      { id: 'A1-PL-Q2', type: 'multiple_choice', skill: 'grammar', question: 'Ona ___ w Krakowie.', options: ['mieszka', 'mieszkam', 'mieszkasz', 'mieszkają'], answer: 'mieszka' },
      { id: 'A1-PL-Q3', type: 'multiple_choice', skill: 'vocabulary', question: 'Przeciwieństwo słowa „duży” to:', options: ['mały', 'wysoki', 'nowy', 'drogi'], answer: 'mały' },
      { id: 'A1-PL-Q4', type: 'multiple_choice', skill: 'grammar', question: 'My ___ kawę rano.', options: ['pijemy', 'pijecie', 'piją', 'piję'], answer: 'pijemy' },
      {
        id: 'A1-PL-Q5',
        type: 'reading_comprehension',
        skill: 'reading',
        text: 'Mam na imię Anna. Mieszkam w Warszawie. Pracuję w sklepie i lubię swoją pracę.',
        questions: [
          { id: 'A1-PL-Q5-1', question: 'Jak ma na imię bohaterka?', options: ['Anna', 'Ala', 'Ewa', 'Maria'], answer: 'Anna' },
          { id: 'A1-PL-Q5-2', question: 'Gdzie pracuje?', options: ['w szkole', 'w sklepie', 'w banku', 'w szpitalu'], answer: 'w sklepie' }
        ]
      },
      { id: 'A1-PL-Q6', type: 'multiple_choice', skill: 'grammar', question: 'Oni ___ bardzo mili.', options: ['są', 'jest', 'jesteś', 'być'], answer: 'są' }
    ]
  },
  {
    stage: 2,
    cefr: 'A2',
    questions: [
      { id: 'A2-PL-Q1', type: 'multiple_choice', skill: 'grammar', question: 'Wczoraj ___ do kina.', options: ['idę', 'poszedłem', 'pójdę', 'chodzę'], answer: 'poszedłem' },
      { id: 'A2-PL-Q2', type: 'multiple_choice', skill: 'grammar', question: 'To jest książka ___ nauczyciela.', options: ['dla', 'od', 'do', 'na'], answer: 'dla' },
      { id: 'A2-PL-Q3', type: 'multiple_choice', skill: 'vocabulary', question: 'Jest bardzo ___, zawsze pomaga ludziom.', options: ['życzliwa', 'leniwa', 'niemiła', 'głośna'], answer: 'życzliwa' },
      { id: 'A2-PL-Q4', type: 'multiple_choice', skill: 'grammar', question: 'Nie ___ go wczoraj.', options: ['widziałem', 'widzę', 'zobaczę', 'widząc'], answer: 'widziałem' },
      {
        id: 'A2-PL-Q5',
        type: 'reading_comprehension',
        skill: 'reading',
        text: 'W zeszłe lato Tomek pojechał do Gdańska. Został tam dwa tygodnie i zwiedził stare miasto.',
        questions: [
          { id: 'A2-PL-Q5-1', question: 'Kiedy Tomek pojechał do Gdańska?', options: ['zimą', 'w zeszłe lato', 'na wiosnę', 'jesienią'], answer: 'w zeszłe lato' },
          { id: 'A2-PL-Q5-2', question: 'Jak długo tam był?', options: ['dwa dni', 'tydzień', 'dwa tygodnie', 'miesiąc'], answer: 'dwa tygodnie' }
        ]
      },
      { id: 'A2-PL-Q6', type: 'multiple_choice', skill: 'grammar', question: 'Wczoraj na imprezie ___ dużo ludzi.', options: ['było', 'byli', 'jest', 'są'], answer: 'było' }
    ]
  },
  {
    stage: 3,
    cefr: 'B1',
    questions: [
      { id: 'B1-PL-Q1', type: 'multiple_choice', skill: 'grammar', question: 'Gdybym miał czas, ___ częściej ćwiczył.', options: ['bym', 'będę', 'jestem', 'byłem'], answer: 'bym' },
      { id: 'B1-PL-Q2', type: 'multiple_choice', skill: 'grammar', question: 'To film, ___ oglądaliśmy wczoraj.', options: ['który', 'która', 'które', 'których'], answer: 'który' },
      { id: 'B1-PL-Q3', type: 'multiple_choice', skill: 'vocabulary', question: 'To rozwiązanie jest bardziej ___.', options: ['praktyczne', 'praktyczny', 'praktyczni', 'praktycznych'], answer: 'praktyczne' },
      { id: 'B1-PL-Q4', type: 'multiple_choice', skill: 'grammar', question: 'To zależy ___ pogody.', options: ['od', 'do', 'na', 'o'], answer: 'od' },
      {
        id: 'B1-PL-Q5',
        type: 'reading_comprehension',
        skill: 'reading',
        text: 'Coraz więcej osób pracuje zdalnie. Część osób oszczędza czas na dojazdach, ale inni narzekają na brak kontaktu z zespołem.',
        questions: [
          { id: 'B1-PL-Q5-1', question: 'Jaka jest zaleta pracy zdalnej?', options: ['wyższa pensja', 'oszczędność czasu', 'mniej obowiązków', 'więcej podróży'], answer: 'oszczędność czasu' },
          { id: 'B1-PL-Q5-2', question: 'Na co narzekają niektórzy?', options: ['na hałas', 'na brak kontaktu', 'na długie spotkania', 'na korki'], answer: 'na brak kontaktu' }
        ]
      },
      { id: 'B1-PL-Q6', type: 'multiple_choice', skill: 'grammar', question: 'Powiedział, że ___ jutro wcześniej.', options: ['przyjedzie', 'przyjechał', 'przyjeżdża', 'przyjeżdżając'], answer: 'przyjedzie' }
    ]
  },
  {
    stage: 4,
    cefr: 'B2',
    questions: [
      { id: 'B2-PL-Q1', type: 'multiple_choice', skill: 'grammar', question: 'Gdyby nie korek, ___ na czas.', options: ['dotarłbym', 'dotrę', 'dotarłem', 'docieram'], answer: 'dotarłbym' },
      { id: 'B2-PL-Q2', type: 'multiple_choice', skill: 'vocabulary', question: 'Jego argumenty były bardzo ___.', options: ['przekonujące', 'przekonujący', 'przekonać', 'przekonaniem'], answer: 'przekonujące' },
      { id: 'B2-PL-Q3', type: 'multiple_choice', skill: 'grammar', question: 'Im więcej czytasz, tym ___ piszesz.', options: ['lepiej', 'dobrze', 'najlepiej', 'lepszy'], answer: 'lepiej' },
      { id: 'B2-PL-Q4', type: 'multiple_choice', skill: 'vocabulary', question: 'Musimy wziąć pod ___ wszystkie koszty.', options: ['uwagę', 'myśl', 'oko', 'punkt'], answer: 'uwagę' },
      {
        id: 'B2-PL-Q5',
        type: 'reading_comprehension',
        skill: 'reading',
        text: 'Miasta inwestują w transport publiczny i infrastrukturę rowerową, aby ograniczyć ruch samochodowy i poprawić jakość powietrza.',
        questions: [
          { id: 'B2-PL-Q5-1', question: 'W co inwestują miasta?', options: ['lotniska', 'autostrady', 'transport i rowery', 'porty'], answer: 'transport i rowery' },
          { id: 'B2-PL-Q5-2', question: 'Po co to robią?', options: ['żeby zwiększyć korki', 'żeby poprawić jakość powietrza', 'żeby zamknąć parki', 'żeby podnieść ceny'], answer: 'żeby poprawić jakość powietrza' }
        ]
      },
      { id: 'B2-PL-Q6', type: 'multiple_choice', skill: 'grammar', question: 'To rozwiązanie, ___ rozważaliśmy, okazało się najlepsze.', options: ['które', 'który', 'którego', 'którym'], answer: 'które' }
    ]
  },
  {
    stage: 5,
    cefr: 'C1',
    questions: [
      { id: 'C1-PL-Q1', type: 'multiple_choice', skill: 'grammar', question: 'Niezależnie od tego, ___ sytuacja się rozwinie, musimy działać konsekwentnie.', options: ['jak', 'że', 'który', 'czyli'], answer: 'jak' },
      { id: 'C1-PL-Q2', type: 'multiple_choice', skill: 'vocabulary', question: 'Jego wypowiedź była na tyle ___, że trudno było ją podważyć.', options: ['spójna', 'spójność', 'spajająca', 'spójnie'], answer: 'spójna' },
      { id: 'C1-PL-Q3', type: 'multiple_choice', skill: 'grammar', question: 'Wypadałoby, aby każdy uczestnik ___ się do dyskusji merytorycznie.', options: ['odniósł', 'odniesie', 'odnosi', 'odnosił'], answer: 'odniósł' },
      { id: 'C1-PL-Q4', type: 'multiple_choice', skill: 'vocabulary', question: 'Firma musiała ___ strategię działania.', options: ['zrewidować', 'rewizja', 'zrewidowany', 'rewidująca'], answer: 'zrewidować' },
      {
        id: 'C1-PL-Q5',
        type: 'reading_comprehension',
        skill: 'reading',
        text: 'Debata o sztucznej inteligencji dotyczy dziś nie tylko technologii, lecz także etyki i odpowiedzialności twórców.',
        questions: [
          { id: 'C1-PL-Q5-1', question: 'Czego dotyczy debata?', options: ['wyłącznie technologii', 'etyki i technologii', 'sportu', 'historii'], answer: 'etyki i technologii' },
          { id: 'C1-PL-Q5-2', question: 'Co podkreśla się coraz częściej?', options: ['brak regulacji', 'odpowiedzialność twórców', 'tańsze komputery', 'rezygnację z AI'], answer: 'odpowiedzialność twórców' }
        ]
      },
      { id: 'C1-PL-Q6', type: 'multiple_choice', skill: 'grammar', question: 'Wyniki badań, ___ opublikowano wczoraj, mogą zmienić podejście do terapii.', options: ['które', 'których', 'którym', 'który'], answer: 'które' }
    ]
  },
  {
    stage: 6,
    cefr: 'C2',
    questions: [
      { id: 'C2-PL-Q1', type: 'multiple_choice', skill: 'vocabulary', question: 'Autor użył ironii, aby ___ absurd sytuacji.', options: ['uwypuklić', 'uwypuklenie', 'uwypuklony', 'uwypuklając'], answer: 'uwypuklić' },
      { id: 'C2-PL-Q2', type: 'multiple_choice', skill: 'grammar', question: 'Było oczywiste, że bez analizy trudno będzie ___ trafne wnioski.', options: ['sformułować', 'formułując', 'sformułowane', 'sformułował'], answer: 'sformułować' },
      { id: 'C2-PL-Q3', type: 'multiple_choice', skill: 'vocabulary', question: 'Język artykułu był precyzyjny i ___.', options: ['komunikatywny', 'komunikować', 'komunikatywnie', 'komunikatywność'], answer: 'komunikatywny' },
      { id: 'C2-PL-Q4', type: 'multiple_choice', skill: 'grammar', question: 'Nawet jeśli teza brzmi przekonująco, należy ją ___ weryfikacji.', options: ['poddać', 'oddawać', 'poddany', 'poddał'], answer: 'poddać' },
      {
        id: 'C2-PL-Q5',
        type: 'reading_comprehension',
        skill: 'reading',
        text: 'Współczesne społeczeństwa żyją w nadmiarze informacji, co utrudnia racjonalne decyzje i sprzyja wybieraniu narracji zgodnych z własnymi przekonaniami.',
        questions: [
          { id: 'C2-PL-Q5-1', question: 'Jaki problem opisuje tekst?', options: ['brak informacji', 'nadmiar informacji', 'brak mediów', 'brak internetu'], answer: 'nadmiar informacji' },
          { id: 'C2-PL-Q5-2', question: 'Co często robi odbiorca?', options: ['analizuje bezstronnie', 'wybiera zgodne narracje', 'unika wiadomości', 'zmienia język'], answer: 'wybiera zgodne narracje' }
        ]
      },
      { id: 'C2-PL-Q6', type: 'multiple_choice', skill: 'grammar', question: 'Trudno przecenić rolę edukacji, ___ celem jest myślenie krytyczne.', options: ['której', 'którą', 'która', 'które'], answer: 'której' }
    ]
  }
];

export const cefrDescriptors = {
  'Pre-A1': { level: 'Pre-A1', description: 'Dopiero zaczynasz naukę języka polskiego i potrzebujesz pracy nad podstawami.', ielts: '—', toefl: '—' },
  'A1': { level: 'A1', description: 'Rozumiesz bardzo proste zwroty i potrafisz komunikować podstawowe potrzeby.', ielts: '—', toefl: '—' },
  'A2': { level: 'A2', description: 'Radziś sobie w codziennych sytuacjach i rozumiesz najczęściej używane wyrażenia.', ielts: '—', toefl: '—' },
  'B1': { level: 'B1', description: 'Potrafisz tworzyć proste, spójne wypowiedzi i funkcjonować w większości typowych sytuacji.', ielts: '—', toefl: '—' },
  'B2': { level: 'B2', description: 'Komunikujesz się płynnie i rozumiesz złożone teksty na różne tematy.', ielts: '—', toefl: '—' },
  'C1': { level: 'C1', description: 'Sprawnie i elastycznie używasz języka również w sytuacjach formalnych.', ielts: '—', toefl: '—' },
  'C2': { level: 'C2', description: 'Bardzo wysoka biegłość językowa: precyzyjnie rozumiesz i tworzysz zniuansowane wypowiedzi.', ielts: '—', toefl: '—' }
};
